export default __webpack_public_path__ + "static/media/duster-colour-8.5fd075ac.jpg";